// client/src/components/ProductSkeleton.js
import React from 'react';
import { Box, Card, Skeleton } from '@mui/material';

const SkeletonCard = () => (
  <Card>
    <Skeleton variant="rectangular" sx={{ aspectRatio: '1 / 1', height: 'auto' }} />
    <Box sx={{ p: 2 }}>
      <Skeleton variant="text" width="40%" height={18} />
      <Skeleton variant="text" width="85%" height={24} />
      <Skeleton variant="text" width="55%" height={28} sx={{ mt: 1 }} />
      <Skeleton variant="rounded" height={36} sx={{ mt: 1.5 }} />
    </Box>
  </Card>
);

// Shape-matched placeholder grid shown while a product list loads.
const ProductSkeleton = ({ count = 8 }) => (
  <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: { xs: 'repeat(2, minmax(0, 1fr))', sm: 'repeat(auto-fill, minmax(230px, 1fr))' } }}>
    {Array.from({ length: count }, (_, i) => <SkeletonCard key={i} />)}
  </Box>
);

export default ProductSkeleton;
